import React from "react";
import "../../../programs.css";

const Pricing = () => {
  return (
    <div className="pricing-container">
      <h1 className="pricing-title">VLSI Program Fee</h1>
      <p className="pricing-subtitle">
        Choose from our different pricing plans for our VLSI.
      </p>
      <div className="pricing-box">
        <div className="pricing-card">
          <h2 className="card-title">Pro Program</h2>
          <hr />
          <ul className="feature-list">
            <li>
              <span className="green">✔</span> Training Certificate
            </li>
            <li>
              <span className="green">✔</span> Internship Certificate with our
              Co-Partnered Company
            </li>
            <li>
              <span className="green">✔</span> 1 Minor + 1 Major Project
            </li>
            <li>
              <span className="green">✔</span> 25+ Hours of video content access
            </li>
            <li>
              <span className="red">✖</span> 16+ Hours of mentor live training
            </li>
            <li>
              <span className="red">✖</span> 10+ Hours of Live Skill Development
              Sessions
            </li>
            <li>
              <span className="red">✖</span> Letter Of Recommendation Based on
              Performance
            </li>
            <li>
              <span className="red">✖</span> Outstanding Certificate for
              Exceptional Performance in Projects
            </li>
          </ul>
          <div className="price-tag">Fee - ₹5,999 /-</div>
          <button className="btn-buy">Choose Plan</button>
        </div>
        {/* ---- Mentor Led Program ---- */}
        <div className="pricing-card">
          <h2 className="card-title">Infinity Program</h2>
          <hr />
          <ul className="feature-list">
            <li>
              <span className="green">✔</span> Training Certificate
            </li>
            <li>
              <span className="green">✔</span> Internship Certificate with our
              Co-Partnered Company
            </li>
            <li>
              <span className="green">✔</span> 1 Minor + 1 Major project
            </li>
            <li>
              <span className="green">✔</span> 25+ Hours of video content access
            </li>
            <li>
              <span className="green">✔</span> 16+ Hours of mentor live training
            </li>
            <li>
              <span className="green">✔</span> 10+ Hours of Live Skill
              Development Sessions
            </li>
            <li>
              <span className="green">✔</span> Letter Of Recommendation Based on
              Performance
            </li>
            <li>
              <span className="green">✔</span> Outstanding Certificate for
              Exceptional Performance in Projects
            </li>
          </ul>
          <div className="price-tag">Fee - ₹9,999 /-</div>
          <button className="btn-buy">Choose Plan</button>
        </div>
      </div>
    </div>
  );
};
export default Pricing;
